import { createContext, useMemo, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider, PaletteMode } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { getTheme, PaletteKey } from "./theme";
import Signup from "./components/signup";
import Login from "./components/login";
import BracketList from "./components/bracket_list";
import BracketMaker from "./components/bracket_creator";
import BracketDisplay from "./components/bracket_display";
import BracketCompare from "./components/bracket_compare";

export const ColorModeContext = createContext({
  toggleColorMode: () => {},
  mode: "light" as PaletteMode,
  paletteKey: "orangeCharcoal" as PaletteKey,
  setPaletteKey: (_key: PaletteKey) => {},
});

const App = () => {
  const [mode, setMode] = useState<PaletteMode>(
    () => (localStorage.getItem("colorMode") as PaletteMode) || "light"
  );
  const [paletteKey, setPaletteKeyState] = useState<PaletteKey>(
    () => (localStorage.getItem("paletteKey") as PaletteKey) || "orangeCharcoal"
  );

  const colorMode = useMemo(
    () => ({
      toggleColorMode: () => {
        setMode((prev) => {
          const next = prev === "light" ? "dark" : "light";
          localStorage.setItem("colorMode", next);
          return next;
        });
      },
      mode,
      paletteKey,
      setPaletteKey: (key: PaletteKey) => {
        localStorage.setItem("paletteKey", key);
        setPaletteKeyState(key);
      },
    }),
    [mode, paletteKey]
  );

  const theme = useMemo(() => getTheme(paletteKey, mode), [paletteKey, mode]);

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <Routes>
            <Route path="/" element={<BracketList />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/create-bracket" element={<BracketMaker />} />
            <Route path="/bracket/:id" element={<BracketDisplay />} />
            <Route path="/compare" element={<BracketCompare />} />
          </Routes>
        </Router>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
};

export default App;
